module.exports = __webpack_public_path__ + "static/media/practice-1.3b0554af.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/practice-1.png
// module id = 622
// module chunks = 0